function MatcherProAgreementText({
  proName
}: Readonly<{ proName: string | null | undefined }>) {
  return (
    <p
      className="text-gray-60 text-1 leading-md text-left mb-4"
      data-testid="matcher_pro_agreement_text"
    >
      By providing your phone and email and selecting See My Pro, you agree to
      be contacted by {proName || 'your pro'} via email, phone, and/or texts,
      and to the use of an automatic telephone dialing system, artificial or
      prerecorded voice, and/or AI-generated messages to advertise and provide
      services to you. Messaging and data rates may apply. Frequency varies.
      <br></br>
      <br></br>
      You may opt out at any time, including by replying STOP to our texts.
      Consent isn’t required for products or services from the pro. However, if
      you opt out of receiving calls or text messages, you won't receive
      communications from the pro.
    </p>
  );
}

export { MatcherProAgreementText };
